<div class="highlights">
  <owl-carousel-o [options]="owlOptions">
    <ng-template carouselSlide>
      <div class="highlights__item">
        <div class="highlights__icon">
          <img
            src="assets/icon-resolution.svg"
            width="58"
            height="39"
            alt="4k icon"
          />
        </div>
        <span>high resolution</span>
      </div>
    </ng-template>
    <ng-template carouselSlide>
      <div class="highlights__item">
        <div class="highlights__icon">
          <img
            src="assets/icon-raw.svg"
            width="58"
            height="28"
            alt="RAW icon"
          />
        </div>
        <span>original files</span>
      </div>
    </ng-template>
    <ng-template carouselSlide>
      <div class="highlights__item">
        <div class="highlights__icon">
          <img
            src="assets/icon-licence.svg"
            width="35"
            height="42"
            alt="Licence icon"
          />
        </div>
        <span>commercial licence</span>
      </div>
    </ng-template>
  </owl-carousel-o>
</div>
